import axios from "axios";
import { banner, webView } from "../../variables/webView";
import GetQrLink from "./getQrLink";
export { GetQrLink };
let token = window.token;

export const QrUpi = async (data) => {
  let response = null;
  try {
    response = await axios.post(
      webView ? `/upi/ajax/new${banner}` : `/upi/ajax/new`,
      {
        qrTitle: data[0],
        upiId: data[1],
        name: data[2],
        currencyId:data[3],
        amount:data[4],
        comment:data[5],
        type:data[6],
        token: token,
        ...(data[7] !== "" && { advertisingIabCategories: data[7] })
      }
    );
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};

export const QrUpiEdit = async (data) => {
  let response = null;
  try {
    response = await axios.post(`/upi/ajax/edit/${data[0]}`, {
      qrTitle: data[1],
      upiId: data[2],
      name: data[3],
      currencyId:data[4],
      amount:data[5],
      comment:data[6],
      type:data[7],
      token: token,
      ...(data[8] !== "" && { advertisingIabCategories: data[8] })
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};
